<template>
    <div id="piSummaryResults" class="search-results-container">

        <!-- <div class="feature-area feature-area-compact">
            <div class="pageHeader">
                <div class="search-results-section">
                    <div class="title-container">
                        <div class="page-title">Active Projects <template v-if="piSummaryProjects && piSummaryProjects.results && piSummaryProjects.results.length > 0">for {{piSummaryProjects.results[0].pi_info[0].name}}</template></div>
                        <div class="sub-title" v-if="piSummaryProjects && piSummaryProjects.meta">
                            {{piSummaryProjects.meta.total |  addCommas}} Project<template v-if="piSummaryProjects.meta.total !== 1">s</template>
                        </div>
                    </div>
                </div>
            </div>
            <div class="sort-note" v-if="!projectListTable.sortField && piSummaryProjects && piSummaryProjects.meta && piSummaryProjects.meta.sorted_by_relevance">Results are sorted by <span>Relevance</span></div>
        </div> -->
        <div class="feature-area-wrapper">
            <div class="feature-area feature-area-compact">
                <div class="pageHeader">
                    <div class="search-results-section">
                        <div class="title-container">

                        </div>
                    </div>
                </div>
                <navigationTabs />
            </div>
        </div>

        <div class="searchResults">
            <div class="adv-results-container" ref="resultsContainer">
                <facets class=""  ref="facets"/>
                <div class="tableContainer">
                    <dataTable class="dataTable" :table="projectListTable" fromPage="piSummary"  ref="dataTable" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions } from 'vuex';
import dataTable from '@/components/global/dataTable.vue';
import facets from '@/components/global/facets.vue';
import globalMixins from '@/globalMixins';
import projectListMixins from '@/projectListMixins';
import searchCriteria from '@/components/global/searchCriteria.vue';
import navigationTabs from '@/components/global/navigationTabs.vue';

export default {
    name: 'piSummary',
    mixins: [globalMixins, projectListMixins],
    components: {
      dataTable,
      facets,
      searchCriteria,
      navigationTabs
    },
    computed: {
        ...mapGetters([
            'piSummaryProjects'
        ]),
    },
    data: function () {
        return {
            serverless: false
        };
    },
    beforeRouteLeave (to, from, next) {
        this.setSearchFacetData(null);
        this.setPersonSummaryProjects(null);
        next();
    },
    mounted () {
        window.scrollTo(0, 0);

        switch (this.$route.name) {
            case 'POSearch':
                this.setSelectedPerson({
                    profile_id: null,
                    name: this.$route.params.po_name,
                    role: 'po'
                });
                break;
            default:
                this.setSelectedPerson({
                    profile_id: this.$route.params.pi_id,
                    name: this.$route.params.pi_name,
                    role: 'pi'
                });
                break;
        }

        // this.setSelectedPerson({
        //     profile_id: this.$route.params.pi_id,
        //     name: this.$route.params.pi_name || this.$route.params.po_name,
        //     role: this.$route.name === 'PISearch' ? 'pi' : 'po'
        // });
        if (!this.piSummaryProjects) {
            this.getProjectsForPersonSummary(this.handlePIProjectListing);
        }
    },
    methods: {
        ...mapActions([
            'setSelectedPerson'
        ]),
        handlePIProjectListing (data) {
            var profileId = this.$route.params.pi_id,
                dataResults,
                j,
                recordFound = false;

            if (data && data.meta) {
                dataResults = data.results;

                for (let i = 0; i < dataResults.length; i++) {
                    for (j = 0; j < dataResults[i].pi_info.length; j++) {
                        if (profileId === dataResults[i].pi_info[j].profile_id.toString()) {
                            this.setSelectedPerson({
                                profile_id: this.$route.params.pi_id,
                                name: dataResults[i].pi_info[j].name,
                                role: 'pi'
                            });
                            recordFound = true;
                            break;
                        }
                    }
                    if (recordFound) {
                        break;
                    }
                }
            }
            this.$router.push({ path: '/search/' + data.meta.search_id + '/projects' });
        },
    }
}
</script>

<style lang="scss" scoped>
@import '@/scss/variables.scss';

    .title-container{
        display: inline-block;
        font-size: 28px;
        .page-title {
            font-size: 28px;
            margin-bottom: 5px;
            margin-right: 15px;
        }
    }

    .sub-title {
        font-size: 16px;
    }

    .widget-button-criteria {
        padding: 3px 10px 1px;
        border-radius: 15px;
        font-weight: 700;

        span {
            display: inline-block;
            margin-right: 5px;
        }

        .widget-button-icon {
            margin-top: -2px;
            margin-right: 6px;
            $icon-size: 13px;
            width: $icon-size;
            height: $icon-size;
            fill: #555;
            transition: 0.3s;
        }

        &:hover,
        &:focus {
            .widget-button-icon {
                fill: #fff;
            }
        }
    }

    .feature-area {
        .search-results-section {
            display: inline-block;
            width: 100%;
        }
    }

    .sort-note {
        position: absolute;
        right: 10px;
        font-size: 16px;
        padding-top: 7px;
        span {
            font-weight: bold;
        }

        @media screen and (max-width: $screen-md-min) {
            position: relative;
            margin-left: 10px;
            margin-bottom: 10px;
        }
    }

</style>